<div class="area-measure esri-widget" [class.hidden]="!active || !showDialog">
    <div #header class="area-measure-header" [class.hidden]="state !== 'measuring' && state !== 'measured'"></div>
    <div #body class="area-measure-body"></div>
    <div #footer class="area-measure-footer esri-direct-line-measurement-3d__actions" [class.hidden]="state !== 'measuring' && state !== 'measured'">
        <button class="area-measure-add-layer esri-button esri-button--secondary"
                [class.btn-disabled]="autolayer || state !== 'measured'"
                (click)="addAsLayer(areaMeasurement2D.viewModel.measurement, areaMeasurement2D.viewModel.measurementLabel)">
            Add as Layer
        </button>
    </div>
    <label class="area-measure-auto-create">
        Auto-create layers
        <input type="checkbox" (change)="autolayer = !autolayer" [checked]="autolayer">
    </label>
</div>
